import React, { useState, useEffect } from 'react';
import { FileTextIcon, ReceiptIcon } from "lucide-react";
import FacturasPage from '../Documentos/FacturasPage';
import DocumentosSoportePage from '../Documentos/DocumentosSoportePage';
import DashboardPage from '../Dashboard/DashboardPage';
import ConfiguracionPage from '../Configuracion/ConfiguracionPage';
import AcercaPage from '../Menu/AcercaPage';
import PanelControlPage from '../Panelcontrol/PanelcontrolPaje';
import InformesPage from '../Informes/InformesPage';
import LoginPage from '../Login/LoginPage';
import DatoscuentaPage from '../Configuracion/DatoscuentaPage';
import AutorizacionesDianFirmaPage from '../Configuracion/AutorizacionesDianFirmaPage';
import UsuariosCuentasPage from '../Configuracion/UsuarioscuentasPage';
import { authService } from '../../services/authService';
import tokenStorage from '../../services/tokenStorage';

import { 
  Home, 
  FileText, 
  Users, 
  Settings, 
  BarChart2, 
  Info, 
  LogOut, 
  ShieldClose,
  ChevronLeft,
  ChevronRight, 
  User, 
  Bell, 
  HelpCircle, 
  ChevronDown, 
  Lock, 
  Eye, 
  EyeOff, 
  Save, 
  CheckCircle2, 
  AlertCircle, 
  X, 
  Shield,
} from 'lucide-react';
import logoFedelza from '../../assets/logo-fedelza.png';

export default function MainLayout() {
  // ESTADOS PRINCIPALES
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const [activePage, setActivePage] = useState('dashboard');
  const [logueado, setLogueado] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  // ESTADOS PARA MENÚ DE USUARIO
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
  });
  const [passwordMessage, setPasswordMessage] = useState('');
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [currentUser, setCurrentUser] = useState({
    name: '',
    email: '',
    role: '',
    identificationNumber: ''
  });

  const version = 'V.1.0.0';
  const buildDate = process.env.REACT_APP_BUILD_DATE || 'Fecha desconocida';

  const colorConfig = {
    dashboard: { 
      bg: 'bg-[#e0f0ff]', 
      text: 'text-[#003865]', 
      shadow: 'shadow-[0_0_10px_#003865]',
      border: '#003865'
    },
    configuracion: { 
      bg: 'bg-[#e3f2fd]', 
      text: 'text-[#1e88e5]', 
      shadow: 'shadow-[0_0_10px_#1e88e5]',
      border: '#1e88e5'
    },
    facturas: { 
      bg: 'bg-[#f0f7ff]', 
      text: 'text-[#0d47a1]', 
      shadow: 'shadow-[0_0_10px_#0d47a1]',
      border: '#0d47a1'
    },
    documentos: { 
      bg: 'bg-[#e8f5e9]', 
      text: 'text-[#2e7d32]', 
      shadow: 'shadow-[0_0_10px_#2e7d32]',
      border: '#2e7d32'
    },
    informes: { 
      bg: 'bg-[#e0f7fa]', 
      text: 'text-[#00838f]', 
      shadow: 'shadow-[0_0_10px_#00838f]',
      border: '#00838f'
    },
    acerca: { 
      bg: 'bg-[#eceff1]', 
      text: 'text-[#37474f]', 
      shadow: 'shadow-[0_0_10px_#37474f]',
      border: '#37474f'
    },
    panelcontrol: { 
      bg: 'bg-[#e0f2f1]', 
      text: 'text-[#00695c]', 
      shadow: 'shadow-[0_0_10px_#00695c]',
      border: '#00695c'
    },
  };

  // ✅ useEffect ÚNICO PARA AUTENTICACIÓN - CORREGIDO
  useEffect(() => {
    const estadoAuth = localStorage.getItem('auth') === 'true';
    setLogueado(estadoAuth);

    // ✅ MOVER LA LÓGICA DE CARGA DE DATOS DENTRO DEL useEffect
    if (estadoAuth) {
      const userData = tokenStorage.getUserData();
      if (userData) {
        setCurrentUser(userData);
        console.log('✅ Datos de usuario cargados desde token:', userData);
      } else {
        // Si no hay datos pero dice autenticado, verificar token
        if (!tokenStorage.hasValidToken() || tokenStorage.isTokenExpired()) {
          console.warn('⚠️ Token inválido, cerrando sesión');
          localStorage.clear();
          setLogueado(false);
        }
      }
    }
  }, []);

  // ACTUALIZAR LA FUNCIÓN handlePasswordChange PARA USAR authService
  const handlePasswordChange = async () => {
    setIsChangingPassword(true);
    setPasswordMessage('');

    // Validaciones
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordMessage({ type: 'error', text: 'Las contraseñas nuevas no coinciden' });
      setIsChangingPassword(false);
      return;
    }

    if (passwordData.newPassword.length < 8) {
      setPasswordMessage({ type: 'error', text: 'La contraseña debe tener al menos 8 caracteres' });
      setIsChangingPassword(false);
      return;
    }

    try {
      // USAR authService CON TOKEN
      await authService.changePassword({
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        identificationNumber: currentUser.identificationNumber
      });
      
      setPasswordMessage({ type: 'success', text: 'Contraseña cambiada exitosamente' });
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      
      setTimeout(() => {
        setShowPasswordModal(false);
        setPasswordMessage('');
      }, 2000);
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      
      let errorMessage = 'Error al cambiar la contraseña';
      
      if (error.message && error.message.includes('token')) {
        errorMessage = 'Sesión expirada. Inicia sesión nuevamente.';
        // Cerrar sesión automáticamente
        setTimeout(() => {
          manejarCerrarSesion();
        }, 2000);
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      setPasswordMessage({ 
        type: 'error', 
        text: errorMessage
      });
    } finally {
      setIsChangingPassword(false);
    }
  };

  const menuOptions = {
    dashboard: { 
      label: 'Inicio', 
      icon: <Home className="h-5 w-5" />, 
      action: () => setActivePage('dashboard') 
    },
    configuracion: { 
      label: 'Mi Cuenta', 
      icon: <Users className="h-5 w-5" />, 
      action: () => setActivePage('configuracion') 
    },
    facturas: { 
      label: 'Facturas Y Notas', 
      icon: <ReceiptIcon className="h-5 w-5" />, 
      action: () => setActivePage('facturas') 
    },
    documentos: { 
      label: 'Documentos Soporte', 
      icon: <FileTextIcon className="h-5 w-5" />, 
      action: () => setActivePage('documentos') 
    },
    informes: { 
      label: 'Informes', 
      icon: <BarChart2 className="h-5 w-5" />, 
      action: () => setActivePage('informes') 
    },
    panelcontrol: { 
      label: 'Panel de Control', 
      icon: <ShieldClose className="h-5 w-5" />, 
      action: () => setActivePage('panelcontrol') 
    },
    acerca: { 
      label: 'Acerca de', 
      icon: <Info className="h-5 w-5" />, 
      action: () => setActivePage('acerca') 
    },
  };

  const activeColor = colorConfig[activePage] || { 
    bg: 'bg-white', 
    text: 'text-gray-800', 
    shadow: '',
    border: '#000000'
  };

  const alternarSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  // Manejar hover del sidebar
  const manejarMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setSidebarHovered(true);
  };

  const manejarMouseLeave = () => {
    const timeout = setTimeout(() => {
      setSidebarHovered(false);
    }, 300);
    setHoverTimeout(timeout);
  };

  // Determinar si el sidebar debe estar visible
  const sidebarVisible = sidebarExpanded || sidebarHovered;

  // Flujo de autenticación
  if (!logueado) {
    if (activePage === 'datosc') {
      return <DatoscuentaPage setActivePage={setActivePage} />;
    }
    return <LoginPage onLogin={() => setLogueado(true)} setActivePage={setActivePage} />;
  }

  const renderizarContenidoPagina = () => {
    switch(activePage) {
      case 'dashboard':
        return <DashboardPage setActivePage={setActivePage} />;
      case 'facturas':
        return <FacturasPage />;
      case 'documentos':
        return <DocumentosSoportePage />;
      case 'configuracion':
        return <ConfiguracionPage />;
      case 'acerca':
        return <AcercaPage />;
      case 'panelcontrol':
        return <PanelControlPage />;
      case 'informes':
        return <InformesPage />;
      case 'preferencias':
        return <DatoscuentaPage />;
      case 'usuarios':
        return <UsuariosCuentasPage />;
      case 'resoluciones':
        return <AutorizacionesDianFirmaPage />;
      default:
        return <DashboardPage setActivePage={setActivePage} />;
    }
  };

  // ACTUALIZAR LA FUNCIÓN manejarCerrarSesion PARA USAR authService
  const manejarCerrarSesion = () => {
    authService.logout(); // Esto limpia automáticamente todo el localStorage
    setLogueado(false);
    setActivePage('dashboard');
    setCurrentUser({ name: '', email: '', role: '', identificationNumber: '' });
    setShowUserMenu(false);
    setShowPasswordModal(false);
    console.log('✅ Sesión cerrada correctamente');
  };

  return (
    <div className="min-h-screen flex font-sans bg-gray-50">
      {/* SIDEBAR */}
      <aside 
        className={`${
          sidebarVisible ? 'w-64' : 'w-16'
        } h-screen fixed top-0 left-0 bg-[#f5f8fa] text-[#2f3542] z-40 transition-all duration-300 ease-in-out overflow-hidden`}
        style={{ 
          borderRight: `2px solid ${activeColor.border}` 
        }}
        onMouseEnter={manejarMouseEnter}
        onMouseLeave={manejarMouseLeave}
      >
        {/* Logo */}
        <div className="flex flex-col items-center tracking-wide bg-gradient-to-tr from-gray-50 to-gray-100 h-16 justify-center">
          <div className="px-2">
            <div className="p-2 bg-gradient-to-br from-white to-gray-50 shadow-md rounded-2xl ring-1 ring-gray-300 hover:shadow-lg transition-shadow duration-300">
              <img
                src={logoFedelza}
                alt="Logo Fedelza"
                className="h-8 w-auto object-contain mx-auto cursor-pointer transition-all duration-300"
                onClick={() => setActivePage('dashboard')}
              />
            </div>
          </div>
        </div>

        {/* Navegación */}
        <nav className={`flex flex-col gap-1 pt-6 text-base font-semibold ${
          sidebarVisible ? 'px-4' : 'px-2'
        }`}>
          {Object.entries(menuOptions).map(([id, { label, icon, action }]) => {
            const isActive = activePage === id;
            const color = colorConfig[id];

            return (
              <div key={id} className="relative group">
                <button
                  onClick={action}
                  className={`flex items-center gap-3 py-2 px-2 rounded-xl transition-all duration-300 border w-full ${
                    isActive
                      ? `${color.bg} ${color.text} ${color.shadow} border-transparent`
                      : `bg-white text-[#2f3542] hover:bg-[#dbe9f4] hover:shadow-md hover:scale-[1.01] border-transparent`
                  } ${sidebarVisible ? 'justify-start px-4' : 'justify-center px-2'}`}
                  aria-label={label}
                  title={!sidebarVisible ? label : ''}
                >
                  <span className={`${isActive ? `${color.text}` : 'text-gray-500'} flex-shrink-0`}>
                    {icon}
                  </span>
                  <span className={`transition-all duration-300 ${
                    sidebarVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 absolute'
                  }`}>
                    {label}
                  </span>
                </button>
                
                {/* Tooltip */}
                {!sidebarVisible && (
                  <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
                    {label}
                  </div>
                )}
              </div>
            );
          })}

          <hr className="my-4 border-gray-200" />

          {/* Cerrar Sesión */}
          <div className="relative group">
            <button
              onClick={manejarCerrarSesion}
              className={`flex items-center gap-3 py-2 px-2 rounded-lg bg-white text-red-500 hover:bg-red-100 hover:text-red-700 hover:shadow-md hover:scale-[1.01] transition-all duration-300 w-full ${
                sidebarVisible ? 'justify-start px-4' : 'justify-center px-2'
              }`}
              aria-label="Cerrar sesión"
              title={!sidebarVisible ? 'Cerrar sesión' : ''}
            >
              <LogOut className="h-5 w-5 flex-shrink-0" />
              <span className={`transition-all duration-300 ${
                sidebarVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 absolute'
              }`}>
                Cerrar sesión
              </span>
            </button>
            
            {!sidebarVisible && (
              <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
                Cerrar sesión
              </div>
            )}
          </div>
        </nav>

        {/* Botón toggle */}
        <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2">
          <button
            onClick={alternarSidebar}
            className="bg-white shadow-lg rounded-full p-2 hover:bg-gray-100 transition-all duration-200"
            aria-label={sidebarExpanded ? 'Contraer barra lateral' : 'Expandir barra lateral'}
          >
            {sidebarExpanded ? (
              <ChevronLeft className="h-4 w-4 text-gray-600" />
            ) : (
              <ChevronRight className="h-4 w-4 text-gray-600" />
            )}
          </button>
        </div>

        {/* Información empresa */}
        <div className="absolute bottom-0 left-0 right-0 border-t-[1.5px] border-blue-300 bg-gradient-to-tr from-gray-50 to-gray-100 h-12 flex items-center justify-center">
          {sidebarVisible ? (
            <div className="text-center px-2">
              <div className="text-xs text-[#2f3542] font-semibold leading-snug">
                Inversiones IDM SAS
              </div>
              <div className="text-xs text-[#2f3542] font-semibold leading-snug">
                NIT. 901.188.189-9
              </div>
            </div>
          ) : (
            <div className="text-[9px] text-[#2f3542] font-bold text-center leading-tight">
              <div>IDM</div>
              <div>SAS</div>
            </div>
          )}
        </div>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <div 
        className={`flex flex-col flex-1 min-h-screen transition-all duration-300 ease-in-out ${
          sidebarVisible ? 'ml-64' : 'ml-16'
        }`}
      >
        {/* HEADER CON MENÚ DE USUARIO */}
        <header 
          className={`h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6 sticky top-0 z-30 ${activeColor.text} shadow-sm`}
        >
          {/* Título de página */}
          <div className="flex items-center gap-3 text-lg font-semibold tracking-tight">
            {menuOptions[activePage]?.icon}
            <span>{menuOptions[activePage]?.label}</span>
          </div>
          
          {/* Sección derecha con usuario */}
          <div className="flex items-center gap-4">
            {/* Información de Versión */}
            <div className="hidden lg:flex flex-col text-xs text-gray-500 font-medium items-end">
              <span>Versión: {version}</span>
              <span>Compilado: {buildDate}</span>
            </div>

            {/* Notificaciones */}
            <button className="relative p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors">
              <Bell className="w-5 h-5" />
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
            </button>

            {/* Ayuda */}
            <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors">
              <HelpCircle className="w-5 h-5" />
            </button>

            {/* Menú de Usuario */}
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center gap-3 p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {/* Avatar */}
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-semibold text-sm">
                    {currentUser.name ? currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
                  </span>
                </div>
                
                {/* Info Usuario */}
                <div className="hidden md:block text-left">
                  <div className="text-sm font-medium text-gray-800">{currentUser.name || 'Usuario'}</div>
                  <div className="text-xs text-gray-600">{currentUser.role || 'Rol'}</div>
                </div>

                <ChevronDown className={`w-4 h-4 text-gray-600 transition-transform ${showUserMenu ? 'rotate-180' : ''}`} />
              </button>

              {/* Dropdown Menú */}
              {showUserMenu && (
                <>
                  <div 
                    className="fixed inset-0 z-10" 
                    onClick={() => setShowUserMenu(false)}
                  ></div>
                  
                  <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
                    {/* Header del menú */}
                    <div className="p-4 border-b border-gray-200">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                          <span className="text-white font-semibold">
                            {currentUser.name ? currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
                          </span>
                        </div>
                        <div>
                          <div className="font-medium text-gray-800">{currentUser.name || 'Usuario'}</div>
                          <div className="text-sm text-gray-600">{currentUser.email || 'email@empresa.com'}</div>
                        </div>
                      </div>
                    </div>

                    {/* Opciones del menú */}
                    <div className="py-2">
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors">
                        <User className="w-4 h-4 text-gray-500" />
                        <span className="text-gray-700">Mi Perfil</span>
                      </button>

                      <button 
                        onClick={() => {
                          setShowPasswordModal(true);
                          setShowUserMenu(false);
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors"
                      >
                        <Lock className="w-4 h-4 text-gray-500" />
                        <span className="text-gray-700">Cambiar Contraseña</span>
                      </button>

                      <button 
                        onClick={() => {
                          setActivePage('configuracion');
                          setShowUserMenu(false);
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors"
                      >
                        <Settings className="w-4 h-4 text-gray-500" />
                        <span className="text-gray-700">Mi Cuenta</span>
                      </button>

                      <div className="border-t border-gray-200 my-2"></div>

                      <button 
                        onClick={manejarCerrarSesion}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-red-50 transition-colors text-red-600"
                      >
                        <LogOut className="w-4 h-4" />
                        <span>Cerrar Sesión</span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </header>

        {/* ÁREA DE CONTENIDO */}
        <main className="flex-1 bg-gray-100 text-[#2f3542] overflow-auto">
          {renderizarContenidoPagina()}
        </main>
      </div>

      {/* ✅ MODAL CAMBIAR CONTRASEÑA - SINTAXIS CORREGIDA */}
      {showPasswordModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
            {/* Header del Modal */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <Shield className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">Cambiar Contraseña</h3>
                  <p className="text-sm text-gray-600">Actualiza tu contraseña de acceso</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowPasswordModal(false);
                  setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
                  setPasswordMessage('');
                }}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Mensaje de Estado */}
            {passwordMessage && (
              <div className={`flex items-center p-3 mb-4 rounded-lg text-sm ${
                passwordMessage.type === 'success' 
                  ? 'text-green-700 bg-green-50 border border-green-200' 
                  : 'text-red-700 bg-red-50 border border-red-200'
              }`}>
                {passwordMessage.type === 'success' ? 
                  <CheckCircle2 className="w-4 h-4 mr-2 flex-shrink-0" /> : 
                  <AlertCircle className="w-4 h-4 mr-2 flex-shrink-0" />
                }
                <span>{passwordMessage.text}</span>
              </div>
            )}

            {/* Campos del Formulario */}
            <div className="space-y-4">
              {/* ✅ CONTRASEÑA ACTUAL - CON PASTE HABILITADO */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Contraseña Actual
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    type={showPasswords.current ? 'text' : 'password'}
                    value={passwordData.currentPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, currentPassword: e.target.value }))}
                    className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                    placeholder="Pega o escribe tu contraseña actual"
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswords(prev => ({ ...prev, current: !prev.current }))}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPasswords.current ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {/* Nueva Contraseña */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nueva Contraseña
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    type={showPasswords.new ? 'text' : 'password'}
                    value={passwordData.newPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, newPassword: e.target.value }))}
                    className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                    placeholder="Ingresa la nueva contraseña"
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswords(prev => ({ ...prev, new: !prev.new }))}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPasswords.new ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {/* Confirmar Contraseña */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Confirmar Nueva Contraseña
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    type={showPasswords.confirm ? 'text' : 'password'}
                    value={passwordData.confirmPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, confirmPassword: e.target.value }))}
                    className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                    placeholder="Confirma la nueva contraseña"
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswords(prev => ({ ...prev, confirm: !prev.confirm }))}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPasswords.confirm ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
            </div>

            {/* Botones */}
            <div className="flex gap-3 mt-6">
              <button
                onClick={handlePasswordChange}
                disabled={isChangingPassword || !passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword}
                className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
              >
                {isChangingPassword ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Cambiando...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4" />
                    Cambiar
                  </>
                )}
              </button>
              
              <button
                onClick={() => {
                  setShowPasswordModal(false);
                  setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
                  setPasswordMessage('');
                }}
                disabled={isChangingPassword}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
              >
                Cancelar
              </button>
            </div>

            {/* Tips de Seguridad */}
            <div className="mt-4 p-3 bg-blue-50 rounded-lg">
              <div className="text-xs text-blue-800">
                <p className="font-medium mb-1">💡 Tips para una contraseña segura:</p>
                <ul className="space-y-1 text-blue-700">
                  <li>• Mínimo 8 caracteres</li>
                  <li>• Combina mayúsculas y minúsculas</li>
                  <li>• Incluye números y símbolos</li>
                  <li>• Evita información personal</li>
                </ul>
              </div>
            </div>

            {/* Información sobre contraseñas generadas */}
            <div className="mt-2 p-3 bg-amber-50 rounded-lg border border-amber-200">
              <div className="text-xs text-amber-800">
                <p className="font-medium mb-1">🔐 ¿Contraseña generada por el sistema?</p>
                <p className="text-amber-700">
                  Si tu contraseña actual fue generada automáticamente, puedes copiarla desde tu gestor de contraseñas o email de bienvenida y pegarla en el campo "Contraseña Actual".
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}